import React from 'react';
import Image from '../../../components/AppImage';

const OrderSummary = ({ orderItems, orderTotal }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <h2 className="text-xl font-semibold text-foreground mb-4">Order Summary</h2>
      
      {/* Order Items */}
      <div className="space-y-4 mb-6">
        {orderItems.map((item) => (
          <div key={item.id} className="flex items-center space-x-4 p-4 bg-muted rounded-lg">
            <div className="w-16 h-16 bg-background rounded-lg overflow-hidden flex-shrink-0">
              <Image
                src={item.image}
                alt={item.name}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-medium text-foreground truncate">{item.name}</h3>
              <p className="text-sm text-muted-foreground">{item.variant}</p>
              <p className="text-sm text-muted-foreground">Qty: {item.quantity}</p>
            </div>
            <div className="text-right">
              <p className="font-semibold text-foreground">${item.price.toFixed(2)}</p>
              {item.originalPrice && item.originalPrice > item.price && (
                <p className="text-xs text-muted-foreground line-through">
                  ${item.originalPrice.toFixed(2)}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
      
      {/* Order Total Breakdown */}
      <div className="border-t border-border pt-4 space-y-2">
        <div className="flex justify-between text-sm">
          <span className="text-muted-foreground">Subtotal:</span>
          <span className="text-foreground">${orderTotal.subtotal.toFixed(2)}</span>
        </div>
        <div className="flex justify-between text-sm">
          <span className="text-muted-foreground">Shipping:</span>
          <span className="text-foreground">
            {orderTotal.shipping === 0 ? 'Free' : `$${orderTotal.shipping.toFixed(2)}`}
          </span>
        </div>
        <div className="flex justify-between text-sm">
          <span className="text-muted-foreground">Tax:</span>
          <span className="text-foreground">${orderTotal.tax.toFixed(2)}</span>
        </div>
        {orderTotal.discount > 0 && (
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Discount:</span>
            <span className="text-success">-${orderTotal.discount.toFixed(2)}</span>
          </div>
        )}
        <div className="border-t border-border pt-2 mt-2">
          <div className="flex justify-between text-lg font-bold">
            <span className="text-foreground">Total:</span>
            <span className="text-foreground">${orderTotal.total.toFixed(2)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;